export default __webpack_public_path__ + "static/media/usergray.879db5e8.svg";